<template>
  <div class="localizedInput">
    <label>
      <div class="title">{{ title }}</div>
      <a class="toggle" href="javascript:void(0)" @click="opened = true"
         v-if="!opened">{{ $t('translation.manage') }}</a>
      <a class="toggle" href="javascript:void(0)" @click="opened = false" v-if="opened">{{ $t('translation.hide') }}</a>
      <Tooltip v-if="tooltip" :text="tooltip"/>
    </label>
    <div class="inputs">
      <template v-for="(language, index) of languages">
        <div class="input" v-show="opened || index === 0" :class="{opened: opened}">
          <label v-if="opened || index !== 0 || language !== locale" class="locale">
            {{ $t(`translation.${language}`) }}
          </label>
          <input v-model.trim="translate[language]" v-if="!isTextArea"
                 :class="[inputClass, validate && validate.error(`${errorsKey}.${language}`) ? 'invalid': '']"
                 :placeholder="placeholder ? placeholder[language] : ''" type="text">
          <textarea v-model.trim="translate[language]" v-if="isTextArea"
                    :class="[inputClass, validate && validate.error(`${errorsKey}.${language}`) ? 'invalid': '']"
                    :placeholder="placeholder ? placeholder[language] : ''"/>
          <MaxSize v-model="translate[language]" v-if="maxSize" :max-size="maxSize"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

  import Tooltip from "@/components/tools/Tooltip.vue";
  import MaxSize from "./MaxSize.vue";

  export default {

    name: "localizedInput",

    components: { MaxSize, Tooltip },

    props: {
      open: Boolean,
      title: String,
      translate: [Object, Array],
      textarea: Boolean,
      tooltip: String,
      validate: Object,
      errorsKey: String,
      maxSize: Number,
      inputClass: String,
      placeholder: {
        type: Object,
        required: false
      },
    },

    async mounted() {
      this.setLanguages();
    },

    data() {
      return {
        opened: this.open || false,
        languages: []
      };
    },

    computed: {
      isTextArea() {
        return !!this.textarea;
      },
      locale() {
        return this.$ts.state.locale;
      }
    },

    methods: {
      async setLanguages() {
        this.languages = await this.$store.getters.getContextLanguages;
        if (!this.languages) {
          let availableLanguages = ['fr','en'].filter(l => l !== this.locale);
          this.languages = [this.locale].concat(availableLanguages);
        }
      }
    }

  }

</script>

<style lang="scss" scoped>

  label {
    display: flex;
    .title {
      flex-grow: 1;
    }
  }

  .locale {
    font-size: 12px;
    color: var(--primary-color);
  }

  .tooltip {
    margin-left: 10px;
  }

  .toggle {
    color: var(--primary-color);
    text-align: right;
    margin-left: 10px;
  }

  .inputs {
    width: 100%;
    display: flex;
    .input {
      flex-grow: 1;
      flex-basis: 0;
      input {
        width: 100%;
      }
      textarea {
        width: 100%;
        height: 6.4em;
        min-height: 6.4em;
        resize: vertical;
        white-space: pre-wrap;
      }
    }
    .input.opened:not(:last-of-type) {
      margin-right: 40px;
    }
  }

</style>
